(() => {
    const wrap   = document.querySelector('.trainings');
    if (!wrap) return;
    const list   = wrap.querySelectorAll('.training');
    const chips  = wrap.querySelector('.chips');

    const uniq = ['__all', ...Array.from(new Set([...list].map(i => i.dataset.city).filter(Boolean)))];

    // dobuduj brakujące chipsy
    uniq.slice(1).forEach(city => {
        const btn = document.createElement('button');
        btn.className = 'chip';
        btn.dataset.city = city;
        btn.role = 'tab';
        btn.textContent = city;
        chips.appendChild(btn);
    });

    function setActive(targetCity){
        chips.querySelectorAll('.chip').forEach(b => {
            const on = (b.dataset.city === targetCity);
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        [...list].forEach(item => {
            const show = targetCity === '__all' || item.dataset.city === targetCity;
            item.hidden = !show;
        });
    }

    chips.addEventListener('click', (e) => {
        const btn = e.target.closest('.chip');
        if (!btn) return;
        setActive(btn.dataset.city);
    });

    setActive('__all'); // start
})();

(() => {
    const root   = document.querySelector('.carousel');
    if (!root) return;

    const slides = Array.from(root.querySelectorAll('.carousel__slide'));
    const media  = slides.map(s => s.querySelector('.carousel__media'));
    const dotsCt = root.querySelector('.carousel__dots');
    const prev   = root.querySelector('.carousel__nav--prev');
    const next   = root.querySelector('.carousel__nav--next');

    let index = 0;
    let lock = false;

    /* ---------- Dots ---------- */
    slides.forEach((_, i) => {
        const d = document.createElement('button');
        d.type = 'button';
        d.className = 'carousel__dot' + (i === 0 ? ' is-active':'');
        d.setAttribute('aria-label', `Przejdź do slajdu ${i+1}`);
        d.addEventListener('click', () => go(i));
        dotsCt.appendChild(d);
    });
    const dots = Array.from(dotsCt.children);

    /* ---------- Nav ---------- */
    prev.addEventListener('click', () => go((index - 1 + slides.length) % slides.length));
    next.addEventListener('click', () => go((index + 1) % slides.length));

    function go(i){
        if (lock || i === index) return;
        lock = true;

        slides[index].classList.remove('is-active');
        dots[index].classList.remove('is-active');
        pauseVideo(media[index]);

        index = i;

        slides[index].classList.add('is-active');
        dots[index].classList.add('is-active');
        loadImage(media[index]);
        playVideo(media[index]);

        setTimeout(() => { lock = false; }, 520); // po animacji fade
    }

    /* ============================================================
       Leniwe ładowanie (SLICD-34) - od razu ładuje się tylko pierwszy slajd.
       Obrazy pozostałych slajdów (data-src) po zdarzeniu load strony, żeby nie
       konkurowały z LCP. Filmy (preload="none") dopiero, gdy slajd jest pokazany -
       na telefonie w wersji 720p.
    ============================================================ */
    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    function loadImage(el){
        if (!el || el.tagName !== 'IMG' || !el.dataset.src) return;
        if (el.dataset.srcset) el.srcset = el.dataset.srcset;
        el.src = el.dataset.src;
        delete el.dataset.src;
        delete el.dataset.srcset;
    }

    function loadPoster(el){
        if (!el || el.tagName !== 'VIDEO' || !el.dataset.poster) return;
        el.poster = el.dataset.poster;
        delete el.dataset.poster;
    }

    function playVideo(el){
        if (!el || el.tagName !== 'VIDEO') return;
        loadPoster(el);
        if (!el.dataset.loaded) {
            el.querySelectorAll('source').forEach(source => {
                source.src = (isMobile && source.dataset.srcMobile) || source.dataset.src;
            });
            el.dataset.loaded = '1';
            // play() przed załadowaniem danych bywa przerywane (np. karta w tle) - ponawiamy po canplay.
            el.addEventListener('canplay', () => {
                if (el.closest('.carousel__slide').classList.contains('is-active')) playVideo(el);
            }, { once: true });
            el.load();
        }
        const playing = el.play();
        if (playing && playing.catch) playing.catch(() => {}); // np. tryb oszczędzania danych
    }

    function pauseVideo(el){
        if (el && el.tagName === 'VIDEO' && el.dataset.loaded) el.pause();
    }

    const loadRest = () => media.forEach(el => { loadImage(el); loadPoster(el); });
    if (document.readyState === 'complete') loadRest();
    else window.addEventListener('load', loadRest, { once: true });

    playVideo(media[index]); // gdyby pierwszym slajdem był film

    /* ============================================================
       Auto-kontrast – zostawiam Twój kod bez zmian
    ============================================================ */
    const VERY_BRIGHT = 210;
    const BRIGHT      = 150;

    media.forEach((img, i) => {
        const slide = slides[i];
        // Filmy pomijamy (jak wcześniej - video nie wysyła zdarzenia load).
        if (!img || img.tagName !== 'IMG') return;

        const applyTone = (brightness, tainted = false) => {
            if (tainted) {
                slide.style.setProperty('--text-color', '#fff');
                slide.classList.add('needs-shade');
                return;
            }
            if (brightness >= BRIGHT) {
                slide.style.setProperty('--text-color', '#0f172a');
                if (brightness >= VERY_BRIGHT) slide.classList.add('needs-shade');
            } else {
                slide.style.setProperty('--text-color', '#fff');
            }
        };

        const analyze = () => {
            try {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d', { willReadFrequently: true });
                const w = 24, h = 24;
                canvas.width = w; canvas.height = h;
                ctx.drawImage(img, 0, 0, w, h);
                const { data } = ctx.getImageData(0, 0, w, h);
                let r=0,g=0,b=0, p = data.length / 4;
                for (let k=0; k<data.length; k+=4){ r+=data[k]; g+=data[k+1]; b+=data[k+2]; }
                r/=p; g/=p; b/=p;
                const brightness = 0.299*r + 0.587*g + 0.114*b;
                applyTone(brightness, false);
            } catch (err) {
                const test = new Image();
                test.crossOrigin = 'anonymous';
                test.onload = () => {
                    try{
                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d', { willReadFrequently: true });
                        const w = 24, h = 24;
                        canvas.width = w; canvas.height = h;
                        ctx.drawImage(test, 0, 0, w, h);
                        const { data } = ctx.getImageData(0, 0, w, h);
                        let r=0,g=0,b=0, p = data.length / 4;
                        for (let k=0; k<data.length; k+=4){ r+=data[k]; g+=data[k+1]; b+=data[k+2]; }
                        r/=p; g/=p; b/=p;
                        const brightness = 0.299*r + 0.587*g + 0.114*b;
                        applyTone(brightness, false);
                    } catch (e){ applyTone(0, true); }
                };
                test.onerror = () => applyTone(0, true);
                test.src = img.currentSrc || img.src;
            }
        };

        // Obraz z data-src nie ma jeszcze src - complete=true, ale nie ma czego analizować.
        if (img.complete && img.currentSrc) analyze();
        else img.addEventListener('load', analyze, { once: true });
    });

    /* ============================================================
       Drag / swipe
    ============================================================ */
    let startX = 0, currentX = 0, isDown = false;

    const start = (x) => {
        isDown = true;
        startX = x;
        currentX = x;
    };

    const move = (x) => {
        if (!isDown) return;
        currentX = x;
    };

    const end = () => {
        if (!isDown) return;
        const diff = currentX - startX;
        if (Math.abs(diff) > 50) {
            if (diff > 0) {
                go((index - 1 + slides.length) % slides.length); // swipe right → prev
            } else {
                go((index + 1) % slides.length); // swipe left → next
            }
        }
        isDown = false;
    };

    root.addEventListener('mousedown', e => start(e.pageX));
    root.addEventListener('mousemove', e => move(e.pageX));
    root.addEventListener('mouseup', end);
    root.addEventListener('mouseleave', () => { if (isDown) end(); });

    root.addEventListener('touchstart', e => start(e.touches[0].clientX));
    root.addEventListener('touchmove', e => move(e.touches[0].clientX));
    root.addEventListener('touchend', end);
})();

/* audiences.js
   Minimal carousel just for the `.audiences` section you pasted.
   - Works in a loop
   - Builds dots in EVERY `.audience__dots` bar
   - Handles Next button, dots click, keyboard (←/→), and drag/swipe
   - Hides nav + dots when there is only one slide
*/

(() => {
    const SELECTION = '.audiences';

    // Allow multiple sections on one page
    document.querySelectorAll(SELECTION).forEach(initAudiences);

    function initAudiences(root) {
        const viewport = root.querySelector('.audiences__viewport');
        const slides   = Array.from(viewport.querySelectorAll('.audience'));
        const dotsBars = Array.from(root.querySelectorAll('.audience__dots'));
        const nextBtn  = root.querySelector('.audiences__next');

        if (!slides.length) return;

        // ---------- State ----------
        let index = 0;
        let lock  = false;

        // ---------- Utilities ----------
        const setAria = () => {
            slides.forEach((s, i) => {
                const active = i === index;
                s.classList.toggle('is-active', active);
                s.setAttribute('aria-hidden', active ? 'false' : 'true');
                s.tabIndex = active ? 0 : -1;
            });

            dotsBars.forEach(bar => {
                const ds = Array.from(bar.children);
                ds.forEach((d, i) => {
                    d.classList.toggle('is-active', i === index);
                    d.setAttribute('aria-selected', i === index ? 'true' : 'false');
                });
            });
        };

        const go = (i) => {
            if (lock || i === index) return;
            lock = true;

            index = (i + slides.length) % slides.length;
            setAria();

            // odblokuj po czasie animacji (dopasuj do CSS jeśli zmienisz)
            window.setTimeout(() => { lock = false; }, 520);
        };

        const buildDots = () => {
            dotsBars.forEach(bar => {
                bar.innerHTML = '';
                slides.forEach((_, i) => {
                    const d = document.createElement('button');
                    d.type = 'button';
                    d.className = 'audience__dot' + (i === 0 ? ' is-active' : '');
                    d.setAttribute('role', 'tab');
                    d.setAttribute('aria-label', `Przejdź do slajdu ${i + 1}`);
                    d.addEventListener('click', () => go(i));
                    bar.appendChild(d);
                });
            });
        };

        // ---------- Init ----------
        buildDots();
        setAria();

        // Hide controls when only one slide
        if (slides.length === 1) {
            nextBtn?.setAttribute('hidden', '');
            dotsBars.forEach(b => b.setAttribute('hidden', ''));
            return; // nothing more to wire
        }

        // ---------- Next button ----------
        if (nextBtn) {
            nextBtn.addEventListener('click', () => go(index + 1));
        }

        // ---------- Keyboard (left/right) ----------
        root.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
            else if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
        });

        // ---------- Drag / Swipe ----------
        let startX = 0;
        let curX   = 0;
        let drag   = false;
        const THRESH = 48; // px

        const start = (x) => { drag = true; startX = curX = x; };
        const move  = (x) => { if (drag) curX = x; };
        const end   = () => {
            if (!drag) return;
            const dx = curX - startX;
            if (Math.abs(dx) > THRESH) {
                if (dx > 0) go(index - 1);
                else go(index + 1);
            }
            drag = false;
        };

        // Mouse
        viewport.addEventListener('mousedown', (e) => start(e.pageX));
        window.addEventListener('mousemove', (e) => move(e.pageX), { passive: true });
        window.addEventListener('mouseup', end);

        // Touch
        viewport.addEventListener('touchstart', (e) => start(e.touches[0].clientX), { passive: true });
        viewport.addEventListener('touchmove',  (e) => move(e.touches[0].clientX), { passive: true });
        viewport.addEventListener('touchend', end);

        // Optional: Auto-resume focusability after click/drag
        viewport.addEventListener('click', () => slides[index].focus?.(), { passive: true });
    }
})();

/* parallax-arrows.js
   - Steruje wyłącznie CSS 'translate' (nie 'transform'), więc nie nadpisze rotate.
   - Scroll w dół: lewa strzałka jedzie w dół, prawa w górę.
   - Inercja (lerp) dla „mac-owego” odczucia.
*/

(() => {
    const wrap  = document.querySelector('.arrows');
    if (!wrap) return;

    const left  = wrap.querySelector('.arrows__left');
    const right = wrap.querySelector('.arrows__right');
    if (!left || !right) return;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // — parametry do strojenia —
    const SPEED_LEFT  = 0.25;   // w px na px scrolla (razem ze scrollem)
    const SPEED_RIGHT = -0.35;  // przeciwnie do scrolla (negatywny → w górę gdy scroll w dół)
    const MAX_SHIFT   = 160;    // maks. odchylenie w px
    const EASE        = 0.10;   // inercja (mniejsze = bardziej „gumowe”)
    const STOP_EPS    = 0.08;   // próg zatrzymania animacji

    let targetL = 0, currentL = 0;
    let targetR = 0, currentR = 0;
    let rafId   = null;

    const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

    function computeTargets() {
        const y = window.scrollY || document.documentElement.scrollTop || 0;
        targetL = clamp(y * SPEED_LEFT,  -MAX_SHIFT, MAX_SHIFT);
        targetR = clamp(y * SPEED_RIGHT, -MAX_SHIFT, MAX_SHIFT);
    }

    function apply() {
        // UŻYWAMY 'translate' zamiast 'transform' — zachowujemy rotate z CSS
        left.style.translate  = `0 ${currentL.toFixed(3)}px`;
        right.style.translate = `0 ${currentR.toFixed(3)}px`;
    }

    function tick() {
        currentL += (targetL - currentL) * EASE;
        currentR += (targetR - currentR) * EASE;
        apply();

        const moving =
            Math.abs(targetL - currentL) > STOP_EPS ||
            Math.abs(targetR - currentR) > STOP_EPS;

        if (moving && !prefersReduced) {
            rafId = requestAnimationFrame(tick);
        } else {
            rafId = null;
        }
    }

    function requestTick() {
        if (rafId == null && !prefersReduced) {
            rafId = requestAnimationFrame(tick);
        }
    }

    function onScroll() {
        if (prefersReduced) return;
        computeTargets();
        requestTick();
    }

    function onResize() {
        onScroll();
    }

    // init
    if (prefersReduced) {
        left.style.translate = '0 0';
        right.style.translate = '0 0';
        return;
    }

    computeTargets();
    apply();
    requestTick();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
})();

(() => {
    const root = document.querySelector('.trainings');
    if (!root) return;

    const list = root.querySelector('.trainings__list');
    const chips = root.querySelector('.chips');
    if (!list || !chips) return;

    const MAX_VISIBLE = 4;

    const items = Array.from(list.querySelectorAll('.training'));
    const allChip = chips.querySelector('.chip[data-city="__all"]');

    let activeCity = '__all';
    let expanded = false;

    // --- CTA "Rozwiń więcej / Zwiń wszystkie"
    const ctaWrap = document.createElement('div');
    ctaWrap.className = 'trainings__more';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn-ghost trainings__more-btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Rozwiń więcej';

    ctaWrap.appendChild(btn);

    // wstaw pod listą, przed dolnym CTA (jeśli istnieje) albo na końcu sekcji
    const bottomCta = root.querySelector('.trainings__cta');
    if (bottomCta) bottomCta.parentNode.insertBefore(ctaWrap, bottomCta);
    else root.appendChild(ctaWrap);

    const setActiveChip = (chipEl) => {
        chips.querySelectorAll('.chip').forEach(c => {
            const isActive = c === chipEl;
            c.classList.toggle('is-active', isActive);
            c.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
    };

    const getFiltered = () => {
        if (activeCity === '__all') return items;
        return items.filter(a => (a.dataset.city || '').trim() === activeCity);
    };

    const render = () => {
        // ukryj wszystko, potem pokaż tylko te z filtra (max 4 jeśli nieexpanded)
        items.forEach(a => a.hidden = true);

        const filtered = getFiltered();
        const visibleCount = expanded ? filtered.length : Math.min(MAX_VISIBLE, filtered.length);

        filtered.forEach((a, idx) => {
            a.hidden = idx >= visibleCount;
        });

        // przycisk ma sens tylko gdy jest >4 w filtrze
        const needsToggle = filtered.length > MAX_VISIBLE;
        ctaWrap.hidden = !needsToggle;

        if (!needsToggle) {
            expanded = false;
            btn.setAttribute('aria-expanded', 'false');
            btn.textContent = 'Rozwiń więcej';
            return;
        }

        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.textContent = expanded ? 'Zwiń wszystkie' : 'Rozwiń więcej';
    };

    // --- klik w chipy (event delegation)
    chips.addEventListener('click', (e) => {
        const chip = e.target.closest('.chip');
        if (!chip) return;

        activeCity = chip.dataset.city || '__all';
        expanded = false; // reset po filtrze

        setActiveChip(chip);
        render();
    });

    // --- toggle "Rozwiń / Zwiń"
    btn.addEventListener('click', () => {
        expanded = !expanded;
        render();
    });

    // --- init
    if (allChip) setActiveChip(allChip);
    render();
})();

